import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sanityClient from "client.js";
import BlockContent from "@sanity/block-content-to-react";

import ExternalLink from 'icons/external-link.js';

import { Row, Col } from 'react-simple-flex-grid';

import "react-simple-flex-grid/lib/main.css";
import imageUrlBuilder from "@sanity/image-url";




import "./index.scss";

var moment = require('moment'); // require


const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source)
}

export default function PressReleasesMap() {
  const [pressReleases, setPressReleases] = useState(null);

  
  useEffect(() => {
    sanityClient.fetch(`*[_type == "pressRelease"] | order(pressReleaseDate desc){
      title,
      slug,
      pressReleaseDate,
      pressFile,
      "fileLink": pressFile.asset->url,
      pressReleaseDescription,
      image,
      link,
      tall,

    }
    `)
    .then((data) => setPressReleases(data))
    .catch(console.error);
  }, []);
  



    return (
      
<Row gutter={0} >
      {pressReleases && pressReleases.map((pressRelease, index) => {
        console.log(pressReleases[1].fileLink);
        console.log(pressReleases[1].slug.current);
        return (
     
        <Col
        
          className="col-visible"
          xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 12 }}
          lg={{ span: 12}} xl={{ span: 12 }}
          key={pressReleases[index].title}
        >
      
              <div className="award-bounds">
                  <div className="award-header">
                    <div className="award-main-text">

                    { pressReleases[index].fileLink ? (
                      <a 
                      //href={`${pressReleases[index].fileLink}?dl=${pressReleases[index].slug.current}.pdf`} 
                      href={`${pressReleases[index].fileLink}`} 
                      target="_blank"
                      key={pressReleases[index].slug}
                      >
                        <div className="award-headline underline">
                          {pressReleases[index].title}
                        </div>
                      </a>
                    ) : (
                      <div className="award-headline">
                        {pressReleases[index].title}
                      </div>
                    )}


                      <div className="award-org">
                   
       
                      </div>
                      <div className="award-date">
                        {moment(pressReleases[index].pressReleaseDate).format('MMM YYYY')}
                      </div>
          
                      
                      
                      
                    </div>
                    {
                      pressReleases[index].image ? (
                        pressReleases[index].project ? (
                          <Link
                            to={"/project/" + pressReleases[index].project.slug.current}
                            key={pressReleases[index].project.slug.current}
                          >
                            <div className={`award-image-box award-image-box-hover ${pressReleases[index].tall ? 'tall-box' : ''}`}>
                              <div className="see-project">
                                {pressReleases[index].project.title}
                              </div>
                              <img
                                src={urlFor(pressReleases[index].image).url()}
                                alt={pressReleases[index].image.alt}
                                key={index}
                                className="award-image award-image-hover"
                              />
                            </div>
                          </Link>
                        ) : pressReleases[index].link ? (
                          <a
                            href={`${pressReleases[index].link}`}
                            target="_blank"
                            key={pressReleases[index].link}
                          >
                            <div className={`award-image-box ${pressReleases[index].tall ? 'tall-box' : ''}`}>
                              <div className="see-project">
                                <ExternalLink/>
                              </div>
                              <img
                                src={urlFor(pressReleases[index].image).url()}
                                alt={pressReleases[index].image.alt}
                                key={index}
                                className="award-image award-image-hover"
                              />
                            </div>
                          </a>
                        ) : (
                          <div className={`award-image-box ${pressReleases[index].tall ? 'tall-box' : ''}`}>
                            <img
                              src={urlFor(pressReleases[index].image).url()}
                              alt={pressReleases[index].image.alt}
                              key={index}
                              className="award-image"
                            />
                          </div>
                        )
                      ) : (
                        <div></div>
                      )
                    }
                  </div>
                  { pressReleases[index].pressReleaseDescription ? 

                  
                  <div className="award-desc">
                    <div></div>
                    <BlockContent
                        blocks={pressReleases[index].pressReleaseDescription}
                        projectId={sanityClient.clientConfig.projectId}
                        dataset={sanityClient.clientConfig.dataset}
                        />
                  </div>
                  : 
                  <div></div>
                  }
              </div>
        </Col>
      )})}
    </Row>

  );
  
}